import React from 'react'
import ReCAPTCHA from "react-google-recaptcha";

const Float = function float ({form,onChange,onSubmit,recaptchaRefRegister,onChangeCountry,onChangeState,onChangeCity,cities,states,countries,forget,formlogin,onChangeLogin,recaptchaRefLogin,onSubmitLogin}){
    return (
        <section>

            <div className="modal userModal" id="userModal">
                <div className="container colflex">
                    <div className="tittle">
                        <h3>Inicia Sesión</h3>
                    </div>
                    
                    <form id="formLogin" action="" onSubmit={onSubmitLogin}>
                        <ReCAPTCHA
                            ref={recaptchaRefLogin}
                            size="invisible"
                            sitekey="6LfcjZ0fAAAAAEqsOPo6f6Cmw9e2din9S2TxcM7m"
                        />
                        <input
                            type="hidden"
                            name="token"
                            value={formlogin.token}
                            onChange={onChangeLogin}
                        />
                        <input
                            name="user"
                            type="text"
                            value={formlogin.user}
                            onChange={onChangeLogin}
                            placeholder="Correo Electronico"
                        />
                        <input
                            name="password"
                            type="password"
                            value={formlogin.password}
                            onChange={onChangeLogin}
                            placeholder="Contraseña"
                        />
                        <br/>
                        <a onClick={forget} className="forgetPass">¿Olvidaste tu contraseña?</a>
                        <br/>
                        <br/>
                        <button type="submit">
                            <a className="initSession">Iniciar sesión</a>
                        </button>
                        <br/>
                        <br/>
                        <a rel="modal:open" href="#userRegister" className="btnRegister">
                            <span>¿No tienes cuenta? </span>REGISTRATE
                        </a>
                    </form>
                </div>
            </div>

            <div className="modal userModal" id="userRegister">
                <div className="container colflex">
                    <div className="tittle">
                        <h3>Registrate</h3>
                    </div>
                    
                    <form id="formRegister" action="" onSubmit={onSubmit}>
                        <ReCAPTCHA
                            ref={recaptchaRefRegister}
                            size="invisible"
                            sitekey="6LfcjZ0fAAAAAEqsOPo6f6Cmw9e2din9S2TxcM7m"
                        />
                        <input
                            type="text"
                            name="name"
                            placeholder="Nombre"
                            value={form.name}
                            onChange={onChange}
                        />
                        <input
                            type="text"
                            name="lastname"
                            placeholder="Apellido"
                            value={form.lastname}
                            onChange={onChange}
                        />
                        <input 
                            type="text" 
                            placeholder="Ingresa tu Cedula (opcional)"
                            name="identy"
                            value={form.identy}
                            onChange={onChange}    
                        />
                        <input
                            type="text"
                            name="mail"
                            placeholder="Correo electronico"
                            value={form.mail}
                            onChange={onChange}
                        />
                        <input 
                            type="password" 
                            placeholder="Ingresa tu Contraseña"
                            name="password"
                            value={form.password}
                            onChange={onChange}       
                        />
                        <input
                            type="text"
                            name="phone"
                            placeholder="Teléfono"
                            value={form.phone}
                            onChange={onChange}
                        />
                        <input 
                            className='address'
                            type="text" 
                            placeholder="Ingresa tu Direccion"
                            name="address"
                            value={form.address}
                            onChange={onChange}           
                        />
                        <select
                            name="city_id"
                            id="city_id"
                            onChange={onChangeCity}
                        >
                            <option>Selecciona tu Ciudad</option>
                            {cities.map((c) => (
                                <option value={c.CiuCodigo} key={c.CiuCodigo}>{c.CiuNombre}</option>
                            ))}
                        </select>
                        <input 
                            type="text" 
                            placeholder="Ingresa tu Barrio"
                            name="town"
                            value={form.town}
                            onChange={onChange}
                        />
                        <textarea
                            name="description"
                            value={form.description}
                            onChange={onChange}
                            placeholder='Detalles adicionales de la dirrecion...'
                        ></textarea>    
                        <div className="policy">
                            <p>*Al registrarte autorizas el <a target="_blank" href={https+'terms'}>uso y tratamiento de datos.</a></p>
                        </div>
                        <button type="submit">
                            <a className="initSession">
                                Continuar
                            </a>
                        </button>
                    </form>
                </div>
            </div>

        </section>
    )
}

export default Float